import { api } from "./api";

export interface AllocationBucket {
  label: string;
  valueCents: number;
  sharePercent: number;
}

export interface Renditebruecke {
  bruecke: number;
  hurdle: number;
  overHurdle: boolean;
  breakdown: { wachstum: number; ausschuettung: number; bewertung: number };
  stale: boolean;
}

export interface WatchlistItemLite {
  id: string;
  symbol: string;
  name: string;
  currency: string;
  investmentCategory: "FELS" | "RAKETE" | null;
  currentPriceCents: number | null;
  currentPriceAsOf: string | null;
  quotesSparkline: number[];
  notes: string | null;
  renditebruecke: Renditebruecke | null;
}

export interface OtterfolioPosition {
  id: string;
  name: string;
  ticker: string | null;
  isin: string | null;
  shares: number;
  avgCostCents: number;
  currentPriceCents: number;
  valueCents: number;
  returnPercent: number;
  sharePercent: number;
  groupSharePercent: number;
  sector: string | null;
  country: string | null;
  investmentCategory: "FELS" | "RAKETE" | null;
  renditebruecke: Renditebruecke | null;
}

export interface GroupPerf {
  valueCents: number;
  weightedReturnPercent: number;
  positionsCount: number;
}

export interface BestWorstEntry {
  id: string;
  name: string;
  gainLossPercent: number;
}

export interface GroupValuePoint {
  date: string;
  totalCents: number;
  felsCents: number;
  raketeCents: number;
  benchmarkCents: number | null;
}

export interface OtterfolioOverview {
  portfolio: "OTTERFOLIO";
  totalValueCents: number;
  investedCents: number;
  returnCents: number;
  returnPercent: number;
  positionsCount: number;
  positions: OtterfolioPosition[];
  allocationByAsset: AllocationBucket[];
  allocationBySector: AllocationBucket[];
  allocationByCountry: AllocationBucket[];
  allocationByCategory: AllocationBucket[];
  categoryTotals: {
    felsCents: number;
    raketeCents: number;
    uncategorizedCents: number;
  };
  fels: GroupPerf;
  rakete: GroupPerf;
  best: BestWorstEntry | null;
  worst: BestWorstEntry | null;
  valueHistory: {
    since_start: GroupValuePoint[];
    last_30d: GroupValuePoint[];
    last_90d: GroupValuePoint[];
  };
  benchmarkLabel: string | null;
  watchlist: WatchlistItemLite[];
}

export async function fetchOtterfolioOverview(): Promise<OtterfolioOverview> {
  return api<OtterfolioOverview>("/otterfolio/overview");
}
